/* global delphi, winformObj */

/*
*  Connection API to Delphi host
*  Alternative connection to CSharp host to keep unified api system
* */
import { EventBus } from '@/event-bus.js'

export default {
  getDongleData () {
    try {
      // call straight function on C# host
      // getDongleData must be defined in host
      let result = winformObj.getDongleData()
      // console.log('getDongleData', result)
      // JSON.parse(result) - obiectul
      // for perfect (and other dongle-requiring apps)
      EventBus.$emit('SetStatusbarInfoDongle', JSON.parse(result))
    } catch (e) {}
  },
  getAllUsers () {
    try {
      // call straight function on C# host
      let result = winformObj.getAllUsers()
      // console.log('getAllUsers', result)
      // JSON.parse(result) - obiectul
      EventBus.$emit('SetUsers', JSON.parse(result))
    } catch (e) {}
  },
  callback (functionName) {
    let args = Array.from(arguments)
    args.shift()
    let parsedArguments = args.map((item) => {
      // console.log('type of argument', typeof item)
      if (typeof item === 'object') { return JSON.stringify(item) }
      return item
    })

    /* Delphi variant */
    if (typeof delphi !== 'undefined') {
      if (parsedArguments.length) {
        delphi.callback(functionName, ...parsedArguments)
      } else {
        delphi.callback(functionName)
      }
    }

    /* CSharp variant */
    // console.log('Calling host function', functionName, parsedArguments)
    // console.log('Passed args', ...parsedArguments)
    if (typeof winformObj !== 'undefined') {
      // function name should start lowercase
      let formattedFunctionName = functionName.charAt(0).toLowerCase() + functionName.slice(1)
      return winformObj[formattedFunctionName](...parsedArguments)

      // if (parsedArguments.length) {
      //   // console.log('Calling server with arguments', parsedArguments)
      //   // console.log('Calling server with ...arguments', ...parsedArguments)
      //   winformObj.invokeFunction(functionName, parsedArguments)
      // } else {
      //   winformObj.invokeFunction(functionName, [])
      // }
    }

    /* Webview2 variant */
    if (window.chrome && window.chrome.webview) {
      // console.log('Sending webview callback')
      const passedObject = { _function: functionName, _args: parsedArguments }
      window.chrome.webview.postMessage(passedObject)
    }
  }
}



// WEBPACK FOOTER //
// ./src/delphi-server.js